import React from 'react'

const Payments = () => {
    return (
        <div className="payments flex-1 bg-gray-500">
            
        </div>
    )
}

export default Payments
